// FAQ Section com Accordion
import { useState } from 'react';
import { faqItems } from '../data/faq';
import { ChevronDown, ChevronUp } from 'lucide-react';

export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleItem = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-20 bg-white dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-12">
          {/* Left: Title */}
          <div className="lg:col-span-1">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white">
              Perguntas
              <br />
              frequentes
            </h2>
          </div>

          {/* Right: FAQ Items */}
          <div className="lg:col-span-3">
            <div className="space-y-4">
              {faqItems.map((item, index) => (
                <div
                  key={item.id}
                  className="border-b border-gray-200 dark:border-gray-800 pb-4 last:border-b-0"
                >
                  <button
                    onClick={() => toggleItem(index)}
                    className="w-full flex items-center justify-between text-left py-4 hover:text-green-600 dark:hover:text-green-400 transition-colors"
                  >
                    <span className="text-lg font-medium text-gray-900 dark:text-gray-100">{item.question}</span>
                    {openIndex === index ? (
                      <ChevronUp className="w-5 h-5 text-green-600 flex-shrink-0" />
                    ) : (
                      <ChevronDown className="w-5 h-5 text-gray-400 flex-shrink-0" />
                    )}
                  </button>
                  {openIndex === index && (
                    <div className="pl-0 pr-8 pb-4">
                      <p className="text-gray-600 dark:text-gray-400 leading-relaxed">{item.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
